// extracted by mini-css-extract-plugin
module.exports = {"container":"FileItem_container_3YVKv","containerOwn":"FileItem_containerOwn_1QNuj","image":"FileItem_image_tXyS6","file":"FileItem_file_1Va9y","text":"FileItem_text_3q2_7"};